/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Matrix from '../Matrix/Matrix';

const ModuleDetail = ({question_groups, org_rol, id, org_id, cat_id, isLocked,
  statusOfModule,setModuleStatus, setLastUpdatedAt, setCatStatus, 
  dispatcher, state, curcat}) => {
  if(!question_groups||question_groups.length===0) {
    return <></>;
  } 
    return (
      <div>
        <div className='row moduleRow'>
          <div className='col-md-9'><label className={'required'} htmlFor={`required field`}>= required field</label>
          </div>
        </div>

        <div id={`moduleDetail-${id}`} tabIndex='-1' role='region' aria-labelledby={`moduleName${id} moduleStatus${id}`}>
          <div className='mqContainer cb-gutterv-24'>
            {
              question_groups.map((qg, index) => {
                qg.cid = cat_id;
                return (<div key={`ma${index}`}>
                  <Matrix json={qg}
                    org_rol={org_rol}
                    org_id={org_id}
                    statusOfModule={statusOfModule}
                    isLocked = {isLocked}
                    first={index===0}
                    setModuleStatus={setModuleStatus}
                    setLastUpdatedAt={setLastUpdatedAt}
                    setCatStatus={setCatStatus}
                    dispatcher={dispatcher} 
                    state={state}
                    curcat={curcat}
                  /></div>);
              })
            }
          </div>
        </div>
      </div>
    );
}

export default ModuleDetail;
